const calculateSpendableAmount = (monthly, oneTime, opexAmount, taxCredit, oneTimeOpex, allowTaxCredit) => {
    let spendableAmount
    if (allowTaxCredit) {
        spendableAmount = (((12 * monthly) + oneTime) - opexAmount) + taxCredit - oneTimeOpex
    } else {
        spendableAmount = (((12 * monthly) + oneTime) - opexAmount) - oneTimeOpex
    }     
    return spendableAmount
}
export default calculateSpendableAmount